import React from 'react';
import { SectionComponent } from 'Features/MyAccount/SectionComponent';
import { useStore } from 'Hooks/useStore';

export const MvpdSubscription = ({ mvpdId }) => {
  const { withMvpds } = useStore('appConfig.strings');
  const mvpd = withMvpds.find((mvpd) => mvpd.mvpdId === mvpdId);

  if (mvpd) {
    const width = 175;
    const height = mvpd.aspectRatio ? width / mvpd.aspectRatio : 'auto';
    return (
      <SectionComponent
        subTitle="Manage Subscription"
        sectionRight={
          <div className="mvpdSubscriptionSection" data-testid="mvpdSubscription">
            <img className="titleLogo" src={mvpd.imageSrc} width={width} height={height} alt={mvpd.name} />
            <div className="manageCopy">You can manage your Fox Nation Subscription on your TV Provider's website.</div>
          </div>
        }
      />
    );
  }
  return null;
};
